export enum NewFeedType {
  BUG = "bug",
  INCIDENT = "incident",
  PROCESS = "process",
  INFO = "information",
  OTHER = "other",
}

export enum NewFeedTypeIcon {
  BUG_ICON = "bug",
  INCIDENT_ICON = "alert",
  PROCESS_ICON = "cog",
  TIP_ICON = "help-circle",
  INFO_ICON = "info-variant",
  GENERAL_ICON = "lightbulb",
  DEFAULT_ICON = "broadcast",
}
